import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-8">
      <button className="w-full py-4 px-2 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-9">
        <span className="font-bold text-gray-900 text-lg" data-id="element-10">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-gray-500" data-id="element-11" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-12" />}
      </button>
      {isOpen && <div className="px-2 pb-4 text-gray-600" data-id="element-13">{answer}</div>}
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Es material digital?',
    answer: 'Sí. Acceso y descarga inmediata.'
  }, {
    question: '¿Sirve para cualquier curso del secundario?',
    answer: 'Sí. Está pensado para todo el nivel secundario.'
  }, {
    question: '¿Funciona para clases presenciales y virtuales?',
    answer: 'Sí, es totalmente adaptable.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No. Todo está explicado paso a paso.'
  }];
  return <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 divide-y divide-gray-200" data-id="element-14">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-15" />)}
    </div>;
}